import SvgComponent from "../../SVGComponent";

// Suggestions of props for component while using the components -------------------------------------
/**
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 */
/**
 * @typedef {("button" | "submit")} BtnType
 * @typedef {("white" | "black")} HoverOption
 * @param {Object} props
 * @param {BtnType} props.btnType - One of "button" or "submit"
 * @param {OnClickEventHandler} props.handleFunction - What to do when click on button
 * @param {boolean} props.isDisabled
 * @param {String} props.enabledBgColor - Color of bg when button is enabled (var only)
 * @param {String} props.disabledBgColor - Color of bg when button is disabled (var only)
 * @param {boolean} props.isLoading - Is something relevant loading right now (loading state)
 * @param {String} props.icon - Takes svg as an props
 * @param {boolean} props.isOpen - Is something relevant that is opened or closed on this state (loading state)
 * @param {String} props.arrowIconUP - Takes svg as an props for arrow up
 * @param {String} props.arrowIconDown - Takes svg as an props for arrow down
 * @param {HoverOption} props.hoverOption - Hover Option Black or White
 * @param {Object} props.buttonRef - Button ref (optional) eg:- state of button ref
 * @param {String} props.title - title/tooltip of the button
 * @param {String} props.imgColor - Takes svg color as an props
 * @param {String} props.arrowIconUPColor - Takes arrowup icon svg color as an props
 * @param {String} props.arrowIconDownColor - Takes arrowdown icon svg color as an props
 * @param {String} props.imgColor - Takes svg color as an props
 * @returns {JSX.Element}
 */
const DualIconRoundButton = ({
  btnType,
  handleFunction,
  isDisabled,
  enabledBgColor,
  disabledBgColor,
  isLoading,
  icon,
  isOpen,
  arrowIconUP,
  arrowIconDown,
  hoverOption,
  buttonRef,
  title,
  imgColor,
  arrowIconUPColor,
  arrowIconDownColor,
}) => {
  return (
    <button
      title={title}
      ref={buttonRef ? buttonRef : null}
      type={btnType !== null ? btnType : "button"}
      onClick={(e) => {
        if (!isLoading) handleFunction(e);
      }}
      className={`flex z-z-index-base relative justify-center items-center p-padding-sm w-auto h-auto rounded-border-radius-md cursor-${
        isDisabled
          ? "not-allowed opacity-light-opacity "
          : `pointer ${
              hoverOption === "white"
                ? "global-hover-white"
                : "global-hover-black"
            }`
      }`}
      style={{
        backgroundColor:
          isDisabled && disabledBgColor
            ? disabledBgColor.toString()
            : enabledBgColor.toString(),
      }}
    >
      <div className="flex flex-row items-center gap-gap-sm">
        <SvgComponent
          color={imgColor}
          height="var(--icon-xs)"
          width="var(--icon-xs)"
          url={icon}
          alt="Icon"
        />
        {isOpen ? (
          <SvgComponent
            color={arrowIconUPColor}
            height="var(--icon-xs)"
            width="var(--icon-xs)"
            url={arrowIconUP}
            alt="Icon"
          />
        ) : (
          <SvgComponent
            color={arrowIconDownColor}
            height="var(--icon-xs)"
            width="var(--icon-xs)"
            url={arrowIconDown}
            alt="Icon"
          />
        )}
      </div>
    </button>
  );
};

export default DualIconRoundButton;
